import styled from "styled-components";
import { useTheme } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";
import axios from "axios";

import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import PaymentInfo from "./components/PaymentInfo";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  background-color: #f7f7f7;
  min-height: 100vh;
  min-height: calc(
    var(--vh, 1vh) * 100
  ); // Check definition in public/index.html
  max-width: ${isMobile ? "unset" : "512px"};
  width: 100%;
  margin: 0 auto;

  header {
    color: ${({ theme }) => theme.palette.primary.contrastText};
    background-color: ${({ theme }) => theme.palette.primary.main};
    padding: 0.75rem;
    font-size: 14pt;
  }
  .loader {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  footer {
    color: ${({ theme }) => theme.palette.primary.contrastText};
    background-color: ${({ theme }) => theme.palette.primary.main};
    font-size: 10pt;
    padding: 0.5rem;
  }
`;

const InvalidLink = styled.main`
  flex: 1;
  padding: 1rem;
  box-shadow: inset 0 7px 9px -7px rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const PaymentScreen = () => {
  const theme = useTheme();
  const { payID } = useParams();
  const [paymentDetails, setPaymentDetails] = useState({});
  const [deeplink, setDeeplink] = useState("");
  const [loading, setLoading] = useState("true");

  useEffect(() => {
    if (payID) {
      axios
        .get(`https://api.shoopy.in/api/v1/pay-links/token/${payID}`)
        .then((response) => {
          const { data } = response;
          // data.status = response.status;
          document.title = `Payment Request - ${data.store_name}`;
          setPaymentDetails(data);
          setLoading(false);
          const pa = data.user_vpa;
          const pn = data.user_name;
          const tn = data.note || `Payment to store ${data.store_name}`;
          const tr = data.id;
          const cu = "INR";
          const am = data.amount;
          const url = data.page_link;
          setDeeplink(
            `pay?pa=${pa}&pn=${pn}&tn=${tn}&tr=${tr}&cu=${cu}&am=${am}&url=${url}`
          );
        })
        .catch((error) => console.log(error));
    }
  }, []);

  return (
    <Container theme={theme}>
      <header>Payment Request</header>
      {loading ? (
        <main className="loader">
          <CircularProgress />
        </main>
      ) : paymentDetails ? (
        <PaymentInfo deeplink={deeplink} paymentDetails={paymentDetails} />
      ) : (
        <InvalidLink>
          <WarningRoundedIcon />
          <div>
            Link invalid or expired. Please contact the seller for a new payment
            link.
          </div>
        </InvalidLink>
      )}
      <footer>Powered by Shoopy</footer>
    </Container>
  );
};

export default PaymentScreen;
